import { Box, Container, Typography } from "@material-ui/core";
import React, { Fragment, useContext, useEffect } from "react";
import useBackButtonRedirect from "../hooks/useBackButton";
import SectionHeader from "../components/SectionHeader";
import { UserDataContext } from "../context/UserDataContext";
import { useLocation, useNavigate } from "react-router-dom";
import { setAnalyticsData } from "../utils/firebaseLog";
import { AuthContext } from "../auth/AuthContext";

export default function RatingComplete() {
  const { fetchUserData, setUserData } = useContext(UserDataContext);
  const { state } = useLocation();
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  useBackButtonRedirect();
  useEffect(() => {
    if (currentUser === undefined) {
      return;
    }
    if (!currentUser) {
      navigate("/login", {
        state: {
          from: window.location.pathname,
          search: window.location.search,
        },
      });
    }
    document.title = "評価とチップ 完了 | じぶん専用IT相談室";
    fetchUserData();
  }, [currentUser]);

  // if (!state) {
  //   navigate("/error?code=404");
  //   return null;
  // }
  return (
    <Box component={"section"} className="section bg-dots">
      <Container className="container">
        <SectionHeader
          currentPage={"ありがとうございました。"}
          preHeading={"Successfull"}
        />
        <Typography className="text-center mobile-text-left">
          評価のご協力、ありがとうございます。
          大切なご意見を今後の業務改善、サービス向上に活かしてまいります。
        </Typography>
      </Container>
      <Box component={"section"} className="section text-center">
        <button className="classification-btn" onClick={() => navigate("/")}>
          ホームへ
        </button>
      </Box>
    </Box>
  );
}
